import { render, staticRenderFns } from "./OrganizerAutonomy.vue?vue&type=template&id=0ee9e66c&"
import script from "./OrganizerAutonomy.vue?vue&type=script&lang=js&"
export * from "./OrganizerAutonomy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports